export {default as data} from './index.json';
import {Component} from 'intact';

export default class extends Component {
    static template = `<div class="browser-mockup">
        <iframe height="350" src="/demo/components/layout/demos/aside/"></iframe>
    </div>`;
}